import React from 'react';
import './Card.css';

const Card2 = (props) => {
  return ( 
    <div className='card'>
        <img  src={props.image} alt="" />
        <h5 className='card-text'>{props.title}</h5>
    </div >
  );
}

export default Card2 ;